module.exports = __webpack_public_path__ + "static/iso_3.9902aedc.jpg";